import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { HitmakerService } from 'src/app/core/services/hitmaker/hitmaker.service';
import { RouterModule, Routes } from '@angular/router';

export interface movies{
  movieDescription:any;
  movieId:any;
  movieName:any;
  heading:any
  movieThumbnailImage:any;
  posterImage:any;
  stages:stages[];
};

export interface stages{
  stageId:any;
  stageName:any;
  stagePosterImage:any;
  stageThumbnailImage:any;
  
};
@Component({
  selector: 'app-hitmaker-movie-page',
  templateUrl: './hitmaker-movie-page.component.html',
  styleUrls: ['./hitmaker-movie-page.component.css']
})
export class HitmakerMoviePageComponent implements OnInit {
  stageName: any;
  movieId: any;
  heading:any
  movieBannerImg:any;
  movieThumbnailImg:any;
  movieDesc: any;
  movieName: any;
  stages: stages;
  stagesOfData: any;
  stageId: any;
  castingDetails: any;
  castingData: any;
  stage1Image: any;
  stage2Image: any;
  stage3Image: any;
  stage4Image: any;
  stage5Image: any;
  showCastingThumbnailValue: any;
  showPreProductionThumbnailValue: any;
  showFilmingThumbnailValue: any;
  showPostProductionThumbnailValue: any;
  showReleaseThumbnailValue: any;
  userId: any;
  releaseStatus: any;
  preProductionStatus: any;
  postProductionStatus: any;
  filmingStatus: any;
  castingStatus: any;
  movieBannerImgForTablet: any;
  movieBannerImgForMobile: any;
  bannerImageUrl: any;
  contests: any
  contestId: any

  constructor( private adminApi: AdminService,
    private hitmakerService: HitmakerService, private activatedRoute: ActivatedRoute, private router: Router)  { }

  ngOnInit(): void {
    this.movieId = this.activatedRoute.snapshot.params['id'];
    
    this.getMovieDetails();
  }

  getMovieDetails(){

      this.adminApi.getHitmakerMoviePage(this.movieId).subscribe(data=>{
        this.stages =data as stages;
        this.movieBannerImg=data.posterImage;
        this.movieBannerImgForTablet = data.posterImageForTablet;
        this.movieBannerImgForMobile = data.posterImageForMobile;
        this.movieDesc=data.movieDescription;
        this.movieName=data.movieName;
        this.heading=data.heading;
        this.releaseStatus = data.releaseStatus;
        this.preProductionStatus = data.preProductionStatus;
        this.postProductionStatus = data.postProductionStatus;
        this.filmingStatus = data.filmingStatus;
        this.castingStatus = data.castingStatus;
        this.stagesOfData = data.stages;
        const urlSegments = this.activatedRoute.snapshot.url;

        this.setBannerImage(window.innerWidth);

        if (urlSegments.length === 1) {
          this.router.navigate(['/hitmaker/' + this.movieId + '/' + this.getmovieName(this.movieName)]);
        }

        this.stagesOfData.forEach((stageData, index) => {
          if (index === 0 && stageData.stageName === 'Casting' && stageData.showThumbnail ) {
            this.showCastingThumbnailValue = true;
            this.stage1Image = stageData.stageThumbnailImage;
          } else if (index === 1 && stageData.stageName === 'Pre-Production' && stageData.showThumbnail) {
            this.showPreProductionThumbnailValue = true;
            this.stage2Image = stageData.stageThumbnailImage;
          } else if (index === 2 && stageData.stageName  === 'Filming' && stageData.showThumbnail) {
            this.showFilmingThumbnailValue = true;
            this.stage3Image = stageData.stageThumbnailImage;
          } else if (index === 3 && stageData.stageName  === 'Post-Production' && stageData.showThumbnail) {
            this.showPostProductionThumbnailValue = true;
            this.stage4Image = stageData.stageThumbnailImage;
          } else if (index === 4 && stageData.stageName  === 'Release' && stageData.showThumbnail) {
            this.showReleaseThumbnailValue = true;
            this.stage5Image = stageData.stageThumbnailImage;
          }
        });
      })
  }   
  onFanCastIt() {
    this.hitmakerService
      .getContestAssociated(this.movieId, 'CASTING')
      .subscribe((res) => {
        console.log(res);

        this.contests = res;
        this.contestId = this.contests;
        console.log(this.contestId.associatedContestId);
        let contestId =this.contestId.associatedContestId;
        if(contestId == 0){
        alert("'FANS CAST IT' contest for this movie is coming soon. Stay tuned!");
        }
        else{
          this.router.navigate(['/contest/' + contestId]);

        }
        return res;
      });
  }
  getStageDetails(stage: any, event: Event) {
    event.preventDefault();
    if(stage ==='casting'){
      this.onFanCastIt()
    }
    else{
     this.router.navigate(['/hitmaker/' + this.movieId + '/stage/' + stage]);
    }
  }
  
  getmovieName(moviename){
    let name = moviename.replace(/[\s?]/g, '-').replace(/["]/g, '');
    return name;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setBannerImage(event.target.innerWidth);
  }
  
  setBannerImage(width: number) {
    if (width > 1023) {
      this.bannerImageUrl = this.movieBannerImg;
    } else if(width > 600 && width < 1024 ) {
      this.bannerImageUrl = this.movieBannerImgForTablet;
    }
    else if(width < 601){
      this.bannerImageUrl = this.movieBannerImgForMobile;
    }
  }
}